// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__AnRXC","content":"LayoutSettings_content__1uDAy"};